/**
 * iter87.199.112 — Privacy Policy stub. Originally a short hardcoded
 * placeholder so the footer's /privacy link had somewhere to land.
 *
 * iter87.199.144 — Replaced the stub with the full `PRIVACY_BODY`
 * (same source `PrivacyModal.jsx` uses), rendered through the shared
 * `renderMarkdownBody` helper so this page matches the style of
 * `/terms` and `/terms/pro-plus-billing`.
 */
import { PRIVACY_BODY } from "@/lib/privacy";
import { renderMarkdownBody } from "@/lib/simpleMarkdown";

export default function PrivacyPage() {
    return (
        <div
            className="min-h-screen bg-[#0a0a0a] text-white px-4 py-8"
            data-testid="privacy-page"
        >
            <div className="max-w-2xl mx-auto space-y-4">
                {renderMarkdownBody(PRIVACY_BODY)}
            </div>
        </div>
    );
}
